module.exports = {
	"type": "object",
	"required": [
		"version",
		"creator",
		"entries"
	],
	"properties": {
		"version": {
			"type": "string"
		},
		"creator": {
			"$ref": "#creator"
		},
		"browser": {
			"$ref": "#creator"
		},
		"pages": {
			"type": "array",
			"items": {
				"$ref": "#page"
			}
		},
		"entries": {
			"type": "array",
			"items": {
				"$ref": "#entry"
			}
		},
		"comment": {
			"type": "string"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/embed-video/~/request/~/har-validator/lib/schemas/log.json
// module id = 354
// module chunks = 0